import React, { FC, ReactNode } from 'react';

import { useTheme } from '../../util/theme';
import HighContrastBorder from '../HighContrastBorder';

import { PageLayoutWidth } from './PageLayout.types';
import { getClassNames } from './PageLayoutLeftSidebar.styles';
export interface PageLayoutLeftSidebarProps {
  readonly fullWidthLayout: boolean;
  readonly topOffset?: number;
  readonly width?: PageLayoutWidth;
  onRenderLeftSidebar(): ReactNode;
}

const PageLayoutLeftSidebar: FC<PageLayoutLeftSidebarProps> = ({
  fullWidthLayout,
  topOffset = 0,
  width,
  onRenderLeftSidebar,
}) => {
  const theme = useTheme();
  const { leftSidebarColumn, leftSidebarBorder } = getClassNames(fullWidthLayout, theme, topOffset, width);

  return (
    <div className={leftSidebarColumn} style={{ position: '-webkit-sticky' }}>
      <HighContrastBorder className={leftSidebarBorder} right={true}>
        {onRenderLeftSidebar()}
      </HighContrastBorder>
    </div>
  );
};

export default PageLayoutLeftSidebar;
